import React from 'react';
import { NavLink } from 'react-router-dom';

const MenuItem = (props) => {
    const isOpen = props.id === props.menuAbertoId;

    const menus = props.filhos
        .filter((menu) => menu.visivel === 1)
        .map(menu =>
            <li key={menu.id}>
                <MenuItem
                    {...props}
                    {...menu}
                    nomeIcone="fa fa-circle icon-submenu"
                />
            </li>
        );

    return (
        <>
            {
                (props.filhos != null && props.filhos.length > 0) ?
                    <>
                        <div onClick={() => props.toggleMenu(props.id)} data-toggle="collapse" className={`menu-link dropdown-toggle d-flex ${(isOpen ? 'menu-aberto' : '')}`}>
                            <i className={props.nomeIcone}></i>
                            <span>{props.nome}</span>
                        </div>
                        <ul className={`collapse list-unstyled sub-menu ${(isOpen ? 'show' : '')}`}>
                            {menus}
                        </ul>
                    </>
                    :
                    <NavLink to={`/${props.url}`}
                        className={({ isActive }) => `menu-link tooltip ${isActive ? ' menu-aberto' : ''}`}
                        onClick={() => props.navigate()}
                    >
                        <i className={props.nomeIcone}></i>
                        <span>{props.nome}</span>
                        <div className="tooltiptext-end">{props.nome}</div>
                    </NavLink>
            }
        </>
    );
};

export default MenuItem;